import * as React from 'react';

interface IEmailConfirmButtonComponent
{
	/** Признак необходимости заполнения */
	IsRequired: boolean,

	/** Признак отключения */
	IsDisabled: boolean,

	/** Признак валидности */
	IsValid: boolean,

	/** Текст */
	Value: string,

	/** Название поля */
	Label: string,

	/** Подсказка поля */
	Placeholder: string,

	/** Текст ошибки */
	Error: string,

	/** Признак подтвержденности */
	IsConfirmed: boolean,

	/** Подтвержденное значение */
	ConfirmedValue: string,

	/**
	 *  Функция, выполняемая при изменении значения инпута
	 *  @value value - измененное значение инпута
	 */
	OnChange: (value: string) => void

	/**
	 *  Функция, выполняемая при валидации значения (если элемент не задизаблен)
	 */
	OnValidate?: () => boolean

	/**
	 *  Функция, выполняемая при нажатии на кнопку
	 */
	OnClick: () => void
}

export const EmailConfirmButtonComponent: React.FC<IEmailConfirmButtonComponent> =
	(
		// входные параметры компонента
		{ IsRequired, IsDisabled, IsValid, Value, Label, Placeholder, Error, IsConfirmed, ConfirmedValue, OnChange, OnValidate, OnClick }: IEmailConfirmButtonComponent
	) =>
	{
		// заворачиваем входные функции в CallBack
		const OnChangeCallback = React.useCallback((event: React.SyntheticEvent, value: string) =>
		{
			OnChange(value);
			if (!IsDisabled && OnValidate) OnValidate();
		}, [OnChange, OnValidate, IsDisabled])

		const OnClickCallback = React.useCallback(() => OnClick(), [OnClick])

		function IsValidText()
		{
			if ((!IsConfirmed && ConfirmedValue.length > 0) || !IsValid) return "invalid";
			return "";
		}

		return (
			<div className="input-text-block">
				<label className={IsValidText() + (IsDisabled ? " filled" : "") + (IsConfirmed ? " confirmed" : "")}>
					<span className="label-title">{Label}&nbsp;{IsRequired && <span className="text-danger">*</span>}</span>
					<span className="row">
						<span className="col-md-6">
							<span className={(IsConfirmed ? "form-text-block with-icon d-block mt-0" : "input-text-block-inline mt-0")}>
								<input
									type="email"
									className="form-text"
									placeholder={Placeholder}
									value={Value}
									disabled={IsDisabled}
									autoComplete="email"
									maxLength={320}
									onChange={(event: React.SyntheticEvent) => OnChangeCallback(event, (event.target as HTMLInputElement).value)}
								/>
								{IsConfirmed && <span className="confirmed-icon"></span>}
							</span>
						</span>
						{!IsConfirmed &&
							<span className="col-md-6">
								<button
									className="btn btn-outline btn-primary mt-2 mt-md-0"
									type="button"
									onClick={OnClickCallback}
									disabled={IsDisabled || Value === ""}
								>Получить ссылку</button>
							</span>
						}
					</span>
					{(!IsConfirmed && ConfirmedValue.length > 0) &&
						<span className="mb-0 error-message text-danger">Изменился адрес электронной почты.<br />Его необходимо подтвердить.</span>
					}
					{(IsConfirmed || ConfirmedValue.length === 0) &&
						<span className="mb-0 error-message text-danger">{Error}</span>
					}
				</label>
			</div>
		)
	}
